<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <div>
    <v-container
      class="px-6"
      style="background: #fafbfc"
    >
      <v-app-bar
        app
        flat
      >
        <v-row>
          <v-col>
            <div class="d-flex align-center">
              <div class="text-h4 font-weight-bold">
                {{ $t('today_sales_statistics') }}
              </div>
              <v-spacer/>
              <div
                class="mt-0"
              >
                <template v-if="isRestaurant">
                  <template v-if="lastZBonPrintTimeTillNow > 5">
                    <v-btn
                      :loading="printLoading"
                      class="mr-2"
                      color="primary"
                      elevation="0"
                      @click="printZbon"
                    >
                      {{ $t('zbonPrint') }}
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn
                      :loading="printLoading"
                      class="mr-2"
                      color="primary"
                      disabled
                      elevation="0"
                      @click="printZbon"
                    >
                      {{ $t('zbonPrint') }}
                    </v-btn>
                  </template>
                  <template v-if="shouldDisplayPrintLastMonthButton">
                    <v-btn
                      class="mr-2"
                      outlined
                      style="background: white"
                      @click="showLastMonthPrintDialog = true"
                    >
                      {{ $t('printLastMonth') }}
                    </v-btn>
                  </template>
                  <v-btn
                    :loading="printLoading"
                    class="mr-2"
                    outlined
                    style="background: white"
                    @click="printTodayBills"
                  >
                    {{ $t('printEmployeeDailyStatement') }}
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn
                    :loading="printLoading"
                    class="mr-2"
                    color="primary"
                    elevation="0"
                    @click="print3in1Today"
                  >
                    {{ $t('printAllOrders') }}
                  </v-btn>
                </template>

                <v-btn
                  :loading="printLoading"
                  class="mr-2"
                  outlined
                  style="background: white"
                  @click="printXBon"
                >
                  {{ $t('printXbon') }}
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-app-bar>
      <v-row
        class="flex-grow-0 mt-8"
      >
        <v-col
          cols="12"
          lg="3"
        >
          <dashboard-card
            :info="togoTotal|priceDisplay"
            :loading="loading"
            :subtitle="$t('includeUnpaid')"
            :title="$t('togoTotalTurnover')"
            color="primary"
            @click="jumpBillsPage"
          />
        </v-col>
        <v-col
          cols="12"
          lg="3"
        >
          <dashboard-card
            :info="inHouseTotal|priceDisplay"
            :loading="loading"
            :subtitle="$t('includeUnpaid')"
            :title="$t('inHouseTurnover')"
            color="primary"
          />
        </v-col>
        <v-col
          cols="12"
          lg="3"
        >
          <dashboard-card
            :info="cashDiff|priceDisplay"
            :loading="loading"
            :subtitle="$t('todayCashChange')"
            :title="$t('alreadyDeductTips')"
            color="orange"
            @click="jumpCashbookPage"
          />
        </v-col>

        <v-col
          cols="12"
          lg="3"
        >
          <dashboard-card
            :info="totalUnpaid|priceDisplay"
            :loading="loading"
            :subtitle="$t('totalOrdersInProgress')"
            :title="$t('unpaidTotalAmount')"
            color="text--darken-2 green"
            @click="jumpBillsPage"
          />
        </v-col>
      </v-row>
      <v-row
        class="flex-grow-0 mt-8"
      >
        <v-col
          cols="12"
        >
          <turnover
            :data-info="info"
            :date="dateRange"
            :label="$t('periodTurnover')"
            class="h-full"
            color="#8c9eff"
            style="height: 100%"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="5"
        >
          <staff-rank
            :date="dateRange"
            :info="info"
            :label="$t('staffData')"
            class="h-full"
            style="height: 100%"
          />
        </v-col>
        <v-col
          cols="3"
        >
          <payment
            :date="dateRange"
            :label="$t('methodPayment')"
            class="h-full"
            style="height: 100%"
          />
        </v-col>
        <v-col
          cols="4"
        >
          <dish-rank
            :date="dateRange"
            :info="info"
            :label="$t('salesList')"
            class="h-full"
            style="height: 100%"
          />
        </v-col>
      </v-row>
      <v-dialog
        v-model="showLastMonthPrintDialog"
        max-width="400px"
      >
        <v-card class="pa-4">
          <div class="text-h4 mt-2">
            <b>{{ $t('printLastMonthData') }}</b>
          </div>
          <div class="mt-8 text-body-1">
            <div class="d-flex align-center">
              <div>{{ $t('printMonthZbon') }}</div>
              <v-spacer/>
              <v-checkbox
                v-model="isPrintMonthZBon"
                class="mr-n4"
                dense
                hide-details
              />
            </div>
            <div class="d-flex align-center">
              <div>{{ $t('printMonthDishStatistic') }}</div>
              <v-spacer/>
              <v-checkbox
                v-model="isPrintMonthDishStatistic"
                class="mr-n4"
                dense
                hide-details
              />
            </div>
            <div class="d-flex align-center">
              <div>{{ $t('sendToEmail') }}</div>
              <v-spacer/>
              <v-checkbox
                v-model="isSendMonthEmail"
                class="mr-n4"
                dense
                hide-details
              />
            </div>
          </div>
          <div class="text-center mt-8">
            <v-btn
              :disabled="shouldDisablePrintButton"
              color="primary"
              elevation="0"
              @click="printLastMonth"
            >
              <div>{{ $t('sure') }}</div>
              <v-icon right>
                mdi-send
              </v-icon>
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
  import StaffRank from '@/views/dashboard/fragment/FastFacts'
  import Turnover from '@/views/dashboard/fragment/Turnover'
  import Payment from '@/views/dashboard/fragment/Payment'
  import DishRank from '@/views/dashboard/fragment/RealTimeStatistic'
  import { loadDashboardData } from '@/model/DashboardService'
  import { defaultDate } from '@/model/common/DateRepository'
  import { previewZBon, print3In1Today, printSummaryBon, printXBon, printZBon, reprintZbon } from '@/common/Utlis/api'
  import IKUtils from 'innerken-js-utils'
  import DashboardCard from '@/views/dashboard/components/DashboardCard'
  import { isRestaurant } from '@/GlobalSettings'
  import { showSuccessMessage, sureTo } from '@/common/utils'
  import i18n from '@/i18n'
  import dayjs from 'dayjs'
  import Zbon from '@/model/export/Zbon'
  import { loadZBonList } from '@/common/common'
  import DishStatistic from '@/model/export/DishStatistic'
  import { predefinedDateRangeDict, standardFormatter } from '@/common/Repository/DateRepository'
  import { today } from 'metaflow-js/EntityFrameWork/DateRepository'

  const timeZone = 6
  export default {
    name: 'NewDashBoard',
    components: {
      DashboardCard,
      DishRank,
      Payment,
      Turnover,
      StaffRank,
    },
    data () {
      return {
        isPrintMonthZBon: true,
        isPrintMonthDishStatistic: true,
        isSendMonthEmail: true,
        showLastMonthPrintDialog: null,

        lastMonthZbonList: [],
        lastMonthDate: null,
        lastZBonPrintTimeTillNow: -1,
        lastZbonPrintDate: null,

        dateRange: [defaultDate, defaultDate],
        isRestaurant: isRestaurant(),
        info: {},
        loading: false,
        billData: null,
        printLoading: false,
      }
    },

    computed: {
      shouldDisablePrintButton () {
        return !this.isPrintMonthDishStatistic && !this.isPrintMonthZBon && !this.isSendMonthEmail
      },
      shouldDisplayPrintLastMonthButton () {
        const condition1 = dayjs(this.localToday.format('YYYY-MM-DD'))
          .diff(standardFormatter(this.localToday.startOf('month')),
                'day') > 4
        const condition2 = dayjs(localStorage.printTime)
          .diff(standardFormatter(this.localToday.startOf('month')),
                'day') < 4
        return condition1 && condition2
      },
      restaurantName () {
        return this.info?.taxInfos?.restaurantInfo?.name ?? i18n.t('loading')
      },
      cashDiff () {
        return this.info?.taxInfos?.content?.cashAmount?.cashAmountDiff ?? 0
      },
      inHouseTotal () {
        return this.info?.salesInfo?.consumeTypeInfo?.find(a => a.consumeTypeId === '1')?.total ?? 0
      },
      togo () {
        return this.info?.salesInfo?.consumeTypeInfo?.find(a => a.consumeTypeId === '2')
      },
      togoTotal () {
        return this.togo?.total ?? 0
      },
      totalUnpaid () {
        return this.info?.taxInfos?.content?.unpaidTotal ?? 0
      },

      localToday () {
        return dayjs().subtract(timeZone, 'hour')
      },

    },
    async mounted () {
      this.lastZbonPrintDate = (await Zbon.getList(true))?.[0]?.printTimeStamp ?? today
      this.lastMonthDate = predefinedDateRangeDict.lastMonth.dateRange()
      this.lastMonthZbonList = await loadZBonList(...this.lastMonthDate)

      await this.reloadData()
      await this.getNewDate()
    },
    methods: {
      printLastMonth () {
        localStorage.setItem('printTime', standardFormatter(this.localToday))
        if (this.isPrintMonthZBon) {
          this.printLastMonthZbon()
        }
        if (this.isPrintMonthDishStatistic) {
          this.printLastMonthDishStatistic()
        }
        if (this.isSendMonthEmail) {
          this.sendLastMonthEmail()
        }
        this.showLastMonthPrintDialog = false
      },
      async sendLastMonthEmail () {
        const selectedItemIds = this.lastMonthZbonList.map(it => it.id)
        try {
          await DishStatistic.printOrSendMail('sendSalesBonEmail', this.lastMonthDate)
          await Zbon.outputMultiplePDF(selectedItemIds)
        } catch
          (e) {
          IKUtils.showError(e)
        }
      },
      async printLastMonthDishStatistic () {
        try {
          await DishStatistic.printOrSendMail('printSalesBon', this.lastMonthDate)
        } catch
          (e) {
          IKUtils.showError(e)
        }
      },
      async printLastMonthZbon () {
        const selectedItemIds = this.lastMonthZbonList.map(it => it.id)
        try {
          for (const i of selectedItemIds) {
            await reprintZbon(i)
          }
        } catch (e) {

        }
      },
      getNewDate () {
        this.lastZBonPrintTimeTillNow = dayjs(this.localToday.format('YYYY-MM-DD HH:mm:ss'))
          .diff(this.lastZbonPrintDate, 'hour')
      },
      async reloadData () {
        await this.$vuetify.goTo(0)
        this.loading = true
        this.info = await loadDashboardData(this.dateRange)
        this.loading = false
        this.billData = await previewZBon(...this.dateRange)
      },
      async printTodayBills () {
        const dates = [...this.dateRange]
        const filter = { timespan: dates ? dates.join(' - ') : '' }
        await sureTo(
          async () => {
            await printSummaryBon(filter)
            showSuccessMessage(this.$t('print_success'))
          },
          this.$t('do_you_want_to_print_all_data_log'))
      },
      async print3in1Today () {
        await sureTo(
          async () => {
            await print3In1Today()
            showSuccessMessage(this.$t('print_success'))
          },
          this.$t('do_you_want_to_print_all_data_log'))
      },
      async printZbon () {
        await sureTo(
          async () => {
            await printZBon()
            showSuccessMessage()
          },
          this.$t('attention_you_are_print_ZBon_all_open_table_will_be_closed_first_warning'))
      },
      async printXBon () {
        await sureTo(
          async () => {
            await printXBon(...this.dateRange)
            showSuccessMessage()
          },
          this.$t('do_you_want_to_print_all_data_log'))
      },
      jumpBillsPage () {
        this.$router.push('bills/history-bills')
      },
      jumpCashbookPage () {
        this.$router.push('bills/cashbook')
      },
    },
  }
</script>

<style lang="sass">
#coloured-line
  .ct-series-a .ct-line,
  .ct-series-a .ct-point
    stroke: #00cae3 !important

  #multiple-bar
    .ct-series-a .ct-bar
      stroke: #00cae3 !important

    .ct-series-b .ct-bar
      stroke: #f44336 !important

  #pie
    .ct-series-a .ct-slice-pie
      fill: #00cae3 !important

    .ct-series-b .ct-slice-pie
      fill: #f44336 !important
</style>
